import { render, staticRenderFns } from "./articalList.vue?vue&type=template&id=b5a2ef32&scoped=true&"
import script from "./articalList.vue?vue&type=script&lang=js&"
export * from "./articalList.vue?vue&type=script&lang=js&"
import style0 from "./articalList.vue?vue&type=style&index=0&id=b5a2ef32&scoped=true&lang=css&"
import style1 from "./articalList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a2ef32",
  null
  
)

export default component.exports